export default "__VITE_ASSET__8c39ec48__"